import React from 'react';
import { Heart, AlertCircle, Stethoscope, BookOpen, Building2, Calendar, MapPin } from 'lucide-react';
import { SEO } from '../components/layout/SEO';
import { Section } from '../components/ui/Section';
import { Card, CardContent } from '../components/ui/Card';
import { FadeIn } from '../components/ui/FadeIn';
import { Carousel } from '../components/ui/Carousel';
export function CharityPage() {
  const earthquakeImages = ['https://cdn.magicpatterns.com/uploads/eygy2SFMuVqM3byhYEvxbj/WhatsApp_Image_2026-01-29_at_11.28.20_AM.jpg', 'https://cdn.magicpatterns.com/uploads/29rfgBHLrjUR7TUSDxUU7M/WhatsApp_Image_2026-01-29_at_11.28.20_AM_(1).jpg', 'https://cdn.magicpatterns.com/uploads/7esoJUsTJswEVyQPbYKgGR/WhatsApp_Image_2026-01-29_at_11.28.20_AM_(2).jpg'];
  const futureProjects = [{
    icon: AlertCircle,
    title: 'Non Communicable Diseases, Awareness and Treatment',
    description: 'Developing programs to address chronic conditions and promote preventive healthcare in underserved communities.'
  }, {
    icon: Stethoscope,
    title: 'Emergency Medicine Management',
    description: 'Supporting emergency medical services and trauma care training for healthcare professionals.'
  }, {
    icon: BookOpen,
    title: 'Education Fund',
    description: 'Continuing our scholarship program to support deserving medical students from Khyber Pakhtunkhwa.'
  }];
  return <>
      <SEO title="Charity" description="Supporting healthcare, education, and humanitarian work through charitable initiatives" data-id="element-225" />

      {/* Hero */}
      <div className="relative bg-[#1e5f4f] text-white py-12 md:py-16 overflow-hidden" data-id="element-226">
        <div className="absolute inset-0 opacity-10" data-id="element-227">
          <img src="https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Humanitarian aid" className="h-full w-full object-cover" data-id="element-228" />
        </div>
        <div className="relative container mx-auto px-4 text-center" data-id="element-229">
          <FadeIn data-id="element-230">
            <Heart className="h-12 w-12 mx-auto mb-4 text-white" data-id="element-231" />
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-3 text-white" data-id="element-232">
              Serving Humanity
            </h1>
            <p className="text-xl text-white max-w-2xl mx-auto leading-relaxed" data-id="element-233">
              We believe healthcare is a fundamental human right. Our charity
              work brings relief, hope, and healing to those who need it most.
            </p>
          </FadeIn>
        </div>
      </div>

      {/* Charity Status */}
      <Section data-id="element-234">
        <div className="max-w-3xl mx-auto" data-id="element-235">
          <FadeIn data-id="element-236">
            <Card className="border-2 border-primary-200 shadow-lg" data-id="element-237">
              <CardContent className="p-6 md:p-8 text-center" data-id="element-238">
                <Building2 className="h-12 w-12 mx-auto mb-3 text-primary-700" data-id="element-239" />
                <h2 className="text-2xl font-serif font-bold text-primary-900 mb-2" data-id="element-240">
                  Khyber Medical Association UK
                </h2>
                <div className="space-y-1 text-base md:text-lg text-gray-700" data-id="element-241">
                  <p data-id="element-242">
                    <strong data-id="element-243">Registered Charity</strong>
                  </p>
                  <p data-id="element-244">
                    Charity Number: <strong data-id="element-245">1097262</strong>
                  </p>
                  <p data-id="element-246">
                    Registered: <strong data-id="element-247">1995</strong>
                  </p>
                </div>
              </CardContent>
            </Card>
          </FadeIn>
        </div>
      </Section>

      {/* Earthquake Relief 2006 - Featured Charity Event */}
      <Section background="gray" data-id="element-248">
        <div className="max-w-5xl mx-auto" data-id="element-249">
          <FadeIn data-id="element-250">
            <Card className="overflow-hidden shadow-xl border-2 border-primary-200" data-id="element-251">
              <CardContent className="p-0" data-id="element-252">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-0" data-id="element-253">
                  {/* Carousel */}
                  <div className="p-6 lg:p-8" data-id="element-254">
                    <Carousel images={earthquakeImages} alt="Earthquake Relief Battagram 2006" data-id="element-255" />
                  </div>

                  {/* Content */}
                  <div className="p-6 lg:p-8 flex flex-col justify-center bg-white" data-id="element-256">
                    <div className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mb-4 self-start" data-id="element-257">
                      Charitable Mission
                    </div>
                    <h3 className="text-3xl font-serif font-bold text-gray-900 mb-3" data-id="element-258">
                      Earthquake Relief Battagram 2006
                    </h3>
                    <p className="text-accent-700 font-semibold mb-4" data-id="element-259">
                      Humanitarian aid and medical support mission
                    </p>
                    <div className="space-y-3 text-sm text-gray-600 mb-6" data-id="element-260">
                      <div className="flex items-start gap-2" data-id="element-261">
                        <Calendar className="h-4 w-4 text-gray-400 shrink-0 mt-0.5" data-id="element-262" />
                        <span data-id="element-263">2006</span>
                      </div>
                      <div className="flex items-start gap-2" data-id="element-264">
                        <MapPin className="h-4 w-4 text-gray-400 shrink-0 mt-0.5" data-id="element-265" />
                        <span data-id="element-266">Battagram, Pakistan</span>
                      </div>
                    </div>
                    <p className="text-gray-700 leading-relaxed" data-id="element-267">
                      Following the devastating earthquake in 2005, KMA UK
                      members organized a relief mission to Battagram, providing
                      essential medical aid, supplies, and support to affected
                      communities. This mission exemplified our commitment to
                      humanitarian service and our dedication to helping those
                      in need during times of crisis.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </FadeIn>
        </div>
      </Section>

      {/* Projects in the Near Future */}
      <Section data-id="element-268">
        <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-269">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-primary-900 mb-2" data-id="element-270">
            Projects in the Near Future
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-271">
          {futureProjects.map((project, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-272">
              <Card className="h-full border-2 border-primary-100 shadow-md" data-id="element-273">
                <CardContent className="p-5 text-center" data-id="element-274">
                  <div className="h-16 w-16 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center mb-3 mx-auto" data-id="element-275">
                    <project.icon className="h-8 w-8" data-id="element-276" />
                  </div>
                  <h3 className="text-lg font-bold text-primary-900 mb-2" data-id="element-277">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-278">
                    {project.description}
                  </p>
                </CardContent>
              </Card>
            </FadeIn>)}
        </div>
      </Section>

      {/* Donation CTA */}
      <Section background="primary" className="text-center" id="donate" data-id="element-279">
        <FadeIn data-id="element-280">
          <Heart className="h-12 w-12 mx-auto mb-4 text-red-400" data-id="element-281" />
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-282">
            Make a Difference Today
          </h2>
          <p className="text-white mb-8 max-w-2xl mx-auto text-lg leading-relaxed" data-id="element-283">
            Your donation supports education, healthcare initiatives, and
            humanitarian work.
          </p>

          <div className="bg-white/10 backdrop-blur rounded-xl p-5 md:p-6 max-w-md mx-auto" data-id="element-284">
            <h3 className="font-bold text-white mb-3 text-lg md:text-xl" data-id="element-285">
              Donation Bank Details
            </h3>
            <div className="space-y-2 text-base md:text-lg text-white/90" data-id="element-286">
              <div className="flex justify-between items-center py-2 border-b border-white/20" data-id="element-287">
                <span className="font-medium" data-id="element-288">Bank</span>
                <span className="font-semibold text-white" data-id="element-289">
                  Royal Bank of Scotland
                </span>
              </div>
              <div className="flex justify-between items-center py-2 border-b border-white/20" data-id="element-290">
                <span className="font-medium" data-id="element-291">Sort Code</span>
                <span className="font-semibold text-white" data-id="element-292">83 46 00</span>
              </div>
              <div className="flex justify-between items-center py-2" data-id="element-293">
                <span className="font-medium" data-id="element-294">Account Number</span>
                <span className="font-semibold text-white" data-id="element-295">00251460</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
}